import { NgModule } from '@angular/core';
import { LoaderComponent } from './layout/loader/loader/loader.component';
import { FooterComponent } from './layout/footer/footer.component';
import { OpenAboutBasketComponent } from './commonComponent/OpenAbout_Basket/OpenAbout_Basket.component';
import { HeaderComponent } from './layout/header/header.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MessagePopupComponent } from './commonComponent/MessagePopup/MessagePopup.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { ConfirmationDialogComponent } from './commonComponent/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './commonComponent/confirmation-dialog/confirmation-dialog.service';
@NgModule({
    imports: [CommonModule, GoogleMapsModule, OpenAboutBasketComponent, MessagePopupComponent, HeaderComponent, FooterComponent, LoaderComponent, ConfirmationDialogComponent],
    exports: [CommonModule, FormsModule, HeaderComponent, FooterComponent, LoaderComponent, OpenAboutBasketComponent, MessagePopupComponent, ConfirmationDialogComponent],
    providers: [ConfirmationDialogService],
})
export class SharedModule { }
